module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-3-d9283e6be3fdfeb80cc0857553bc2e7d.jpg";